export const BellIcon = () => (
  <svg viewBox='0 0 34 34' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M25.5 11.3333C25.5 9.07891 24.6045 6.9169 23.0104 5.32284C21.4163 3.72879 19.2543 2.83325 17 2.83325C14.7457 2.83325 12.5837 3.72879 10.9896 5.32284C9.39553 6.9169 8.5 9.07891 8.5 11.3333C8.5 21.2499 4.25 24.0833 4.25 24.0833H29.75C29.75 24.0833 25.5 21.2499 25.5 11.3333Z'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M19.4507 29.75C19.2017 30.1794 18.8442 30.5358 18.4141 30.7835C17.9839 31.0312 17.4963 31.1616 16.9999 31.1616C16.5035 31.1616 16.0159 31.0312 15.5858 30.7835C15.1556 30.5358 14.7981 30.1794 14.5491 29.75'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
